import * as K from "yup";
import { identityApi as ht } from "@commerce-identity-webcomponents/sdk";
import { E as ut } from "./profileEnums-19fc85bb.mjs";
import { c as Mt } from "./profileApi-67ce01f8.mjs";
import { s as J, d as It, i as bt, w as Et } from "./accountLifeCycleUtils-882119d0.mjs";
import { V as dt, y as Ot, T as Nt, F as Lt, t as W, d as pt, P as yt, z as $t, r as lt } from "./Constants-806cf392.mjs";
import { r as _t } from "./PersonalIdRequest-635e09d2.mjs";
import { P as Ft } from "./Logger-557916b1.mjs";
import { l as et } from "./Storage-2cfab493.mjs";
import { AccountType as Yt } from "@nextgen-web-framework/all";
import { d as gt, i as xt, p as St, b as Rt } from "./helper-bf315385.mjs";
import { UernameContactTypeEnum as ft } from "./utils/types/enum.js";
const ot = {
  Front: "FRONT",
  Back: "BACK"
};
var Q = /* @__PURE__ */ ((e) => (e.INPUT = "INPUT", e.CALENDER = "CALENDAR", e.CHECKBOX = "CHECKBOX", e.CUSTOM = "CUSTOM", e.FILE = "FILE", e.DYNAMIC = "DYNAMIC", e))(Q || {}), Dt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function At(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var wt = { exports: {} };
(function(e, r) {
  (function(n, o) {
    e.exports = o();
  })(Dt, function() {
    var n = 1e3, o = 6e4, s = 36e5, f = "millisecond", l = "second", i = "minute", t = "hour", M = "day", m = "week", A = "month", T = "quarter", E = "year", F = "date", k = "Invalid Date", g = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, D = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, v = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(h) {
      var c = ["th", "st", "nd", "rd"], a = h % 100;
      return "[" + h + (c[(a - 20) % 10] || c[a] || c[0]) + "]";
    } }, C = function(h, c, a) {
      var d = String(h);
      return !d || d.length >= c ? h : "" + Array(c + 1 - d.length).join(a) + h;
    }, B = { s: C, z: function(h) {
      var c = -h.utcOffset(), a = Math.abs(c), d = Math.floor(a / 60), u = a % 60;
      return (c <= 0 ? "+" : "-") + C(d, 2, "0") + ":" + C(u, 2, "0");
    }, m: function h(c, a) {
      if (c.date() < a.date())
        return -h(a, c);
      var d = 12 * (a.year() - c.year()) + (a.month() - c.month()), u = c.clone().add(d, A), p = a - u < 0, y = c.clone().add(d + (p ? -1 : 1), A);
      return +(-(d + (a - u) / (p ? u - y : y - u)) || 0);
    }, a: function(h) {
      return h < 0 ? Math.ceil(h) || 0 : Math.floor(h);
    }, p: function(h) {
      return { M: A, y: E, w: m, d: M, D: F, h: t, m: i, s: l, ms: f, Q: T }[h] || String(h || "").toLowerCase().replace(/s$/, "");
    }, u: function(h) {
      return h === void 0;
    } }, L = "en", x = {};
    x[L] = v;
    var O = "$isDayjsObject", N = function(h) {
      return h instanceof P || !(!h || !h[O]);
    }, R = function h(c, a, d) {
      var u;
      if (!c)
        return L;
      if (typeof c == "string") {
        var p = c.toLowerCase();
        x[p] && (u = p), a && (x[p] = a, u = p);
        var y = c.split("-");
        if (!u && y.length > 1)
          return h(y[0]);
      } else {
        var S = c.name;
        x[S] = c, u = S;
      }
      return !d && u && (L = u), u || !d && L;
    }, w = function(h, c) {
      if (N(h))
        return h.clone();
      var a = typeof c == "object" ? c : {};
      return a.date = h, a.args = arguments, new P(a);
    }, $ = B;
    $.l = R, $.i = N, $.w = function(h, c) {
      return w(h, { locale: c.$L, utc: c.$u, x: c.$x, $offset: c.$offset });
    };
    var P = function() {
      function h(a) {
        this.$L = R(a.locale, null, !0), this.parse(a), this.$x = this.$x || a.x || {}, this[O] = !0;
      }
      var c = h.prototype;
      return c.parse = function(a) {
        this.$d = function(d) {
          var u = d.date, p = d.utc;
          if (u === null)
            return /* @__PURE__ */ new Date(NaN);
          if ($.u(u))
            return /* @__PURE__ */ new Date();
          if (u instanceof Date)
            return new Date(u);
          if (typeof u == "string" && !/Z$/i.test(u)) {
            var y = u.match(g);
            if (y) {
              var S = y[2] - 1 || 0, I = (y[7] || "0").substring(0, 3);
              return p ? new Date(Date.UTC(y[1], S, y[3] || 1, y[4] || 0, y[5] || 0, y[6] || 0, I)) : new Date(y[1], S, y[3] || 1, y[4] || 0, y[5] || 0, y[6] || 0, I);
            }
          }
          return new Date(u);
        }(a), this.init();
      }, c.init = function() {
        var a = this.$d;
        this.$y = a.getFullYear(), this.$M = a.getMonth(), this.$D = a.getDate(), this.$W = a.getDay(), this.$H = a.getHours(), this.$m = a.getMinutes(), this.$s = a.getSeconds(), this.$ms = a.getMilliseconds();
      }, c.$utils = function() {
        return $;
      }, c.isValid = function() {
        return this.$d.toString() !== k;
      }, c.isSame = function(a, d) {
        var u = w(a);
        return this.startOf(d) <= u && u <= this.endOf(d);
      }, c.isAfter = function(a, d) {
        return w(a) < this.startOf(d);
      }, c.isBefore = function(a, d) {
        return this.endOf(d) < w(a);
      }, c.$g = function(a, d, u) {
        return $.u(a) ? this[d] : this.set(u, a);
      }, c.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, c.valueOf = function() {
        return this.$d.getTime();
      }, c.startOf = function(a, d) {
        var u = this, p = !!$.u(d) || d, y = $.p(a), S = function(V, Y) {
          var U = $.w(u.$u ? Date.UTC(u.$y, Y, V) : new Date(u.$y, Y, V), u);
          return p ? U : U.endOf(M);
        }, I = function(V, Y) {
          return $.w(u.toDate()[V].apply(u.toDate("s"), (p ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Y)), u);
        }, b = this.$W, _ = this.$M, j = this.$D, G = "set" + (this.$u ? "UTC" : "");
        switch (y) {
          case E:
            return p ? S(1, 0) : S(31, 11);
          case A:
            return p ? S(1, _) : S(0, _ + 1);
          case m:
            var q = this.$locale().weekStart || 0, z = (b < q ? b + 7 : b) - q;
            return S(p ? j - z : j + (6 - z), _);
          case M:
          case F:
            return I(G + "Hours", 0);
          case t:
            return I(G + "Minutes", 1);
          case i:
            return I(G + "Seconds", 2);
          case l:
            return I(G + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, c.endOf = function(a) {
        return this.startOf(a, !1);
      }, c.$set = function(a, d) {
        var u, p = $.p(a), y = "set" + (this.$u ? "UTC" : ""), S = (u = {}, u[M] = y + "Date", u[F] = y + "Date", u[A] = y + "Month", u[E] = y + "FullYear", u[t] = y + "Hours", u[i] = y + "Minutes", u[l] = y + "Seconds", u[f] = y + "Milliseconds", u)[p], I = p === M ? this.$D + (d - this.$W) : d;
        if (p === A || p === E) {
          var b = this.clone().set(F, 1);
          b.$d[S](I), b.init(), this.$d = b.set(F, Math.min(this.$D, b.daysInMonth())).$d;
        } else
          S && this.$d[S](I);
        return this.init(), this;
      }, c.set = function(a, d) {
        return this.clone().$set(a, d);
      }, c.get = function(a) {
        return this[$.p(a)]();
      }, c.add = function(a, d) {
        var u, p = this;
        a = Number(a);
        var y = $.p(d), S = function(_) {
          var j = w(p);
          return $.w(j.date(j.date() + Math.round(_ * a)), p);
        };
        if (y === A)
          return this.set(A, this.$M + a);
        if (y === E)
          return this.set(E, this.$y + a);
        if (y === M)
          return S(1);
        if (y === m)
          return S(7);
        var I = (u = {}, u[i] = o, u[t] = s, u[l] = n, u)[y] || 1, b = this.$d.getTime() + a * I;
        return $.w(b, this);
      }, c.subtract = function(a, d) {
        return this.add(-1 * a, d);
      }, c.format = function(a) {
        var d = this, u = this.$locale();
        if (!this.isValid())
          return u.invalidDate || k;
        var p = a || "YYYY-MM-DDTHH:mm:ssZ", y = $.z(this), S = this.$H, I = this.$m, b = this.$M, _ = u.weekdays, j = u.months, G = u.meridiem, q = function(Y, U, X, Z) {
          return Y && (Y[U] || Y(d, p)) || X[U].slice(0, Z);
        }, z = function(Y) {
          return $.s(S % 12 || 12, Y, "0");
        }, V = G || function(Y, U, X) {
          var Z = Y < 12 ? "AM" : "PM";
          return X ? Z.toLowerCase() : Z;
        };
        return p.replace(D, function(Y, U) {
          return U || function(X) {
            switch (X) {
              case "YY":
                return String(d.$y).slice(-2);
              case "YYYY":
                return $.s(d.$y, 4, "0");
              case "M":
                return b + 1;
              case "MM":
                return $.s(b + 1, 2, "0");
              case "MMM":
                return q(u.monthsShort, b, j, 3);
              case "MMMM":
                return q(j, b);
              case "D":
                return d.$D;
              case "DD":
                return $.s(d.$D, 2, "0");
              case "d":
                return String(d.$W);
              case "dd":
                return q(u.weekdaysMin, d.$W, _, 2);
              case "ddd":
                return q(u.weekdaysShort, d.$W, _, 3);
              case "dddd":
                return _[d.$W];
              case "H":
                return String(S);
              case "HH":
                return $.s(S, 2, "0");
              case "h":
                return z(1);
              case "hh":
                return z(2);
              case "a":
                return V(S, I, !0);
              case "A":
                return V(S, I, !1);
              case "m":
                return String(I);
              case "mm":
                return $.s(I, 2, "0");
              case "s":
                return String(d.$s);
              case "ss":
                return $.s(d.$s, 2, "0");
              case "SSS":
                return $.s(d.$ms, 3, "0");
              case "Z":
                return y;
            }
            return null;
          }(Y) || y.replace(":", "");
        });
      }, c.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, c.diff = function(a, d, u) {
        var p, y = this, S = $.p(d), I = w(a), b = (I.utcOffset() - this.utcOffset()) * o, _ = this - I, j = function() {
          return $.m(y, I);
        };
        switch (S) {
          case E:
            p = j() / 12;
            break;
          case A:
            p = j();
            break;
          case T:
            p = j() / 3;
            break;
          case m:
            p = (_ - b) / 6048e5;
            break;
          case M:
            p = (_ - b) / 864e5;
            break;
          case t:
            p = _ / s;
            break;
          case i:
            p = _ / o;
            break;
          case l:
            p = _ / n;
            break;
          default:
            p = _;
        }
        return u ? p : $.a(p);
      }, c.daysInMonth = function() {
        return this.endOf(A).$D;
      }, c.$locale = function() {
        return x[this.$L];
      }, c.locale = function(a, d) {
        if (!a)
          return this.$L;
        var u = this.clone(), p = R(a, d, !0);
        return p && (u.$L = p), u;
      }, c.clone = function() {
        return $.w(this.$d, this);
      }, c.toDate = function() {
        return new Date(this.valueOf());
      }, c.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, c.toISOString = function() {
        return this.$d.toISOString();
      }, c.toString = function() {
        return this.$d.toUTCString();
      }, h;
    }(), H = P.prototype;
    return w.prototype = H, [["$ms", f], ["$s", l], ["$m", i], ["$H", t], ["$W", M], ["$M", A], ["$y", E], ["$D", F]].forEach(function(h) {
      H[h[1]] = function(c) {
        return this.$g(c, h[0], h[1]);
      };
    }), w.extend = function(h, c) {
      return h.$i || (h(c, P, w), h.$i = !0), w;
    }, w.locale = R, w.isDayjs = N, w.unix = function(h) {
      return w(1e3 * h);
    }, w.en = x[L], w.Ls = x, w.p = {}, w;
  });
})(wt);
var Pt = wt.exports;
const tt = /* @__PURE__ */ At(Pt);
var Ct = { exports: {} };
(function(e, r) {
  (function(n, o) {
    e.exports = o();
  })(Dt, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, o = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, s = /\d/, f = /\d\d/, l = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, t = {}, M = function(g) {
      return (g = +g) + (g > 68 ? 1900 : 2e3);
    }, m = function(g) {
      return function(D) {
        this[g] = +D;
      };
    }, A = [/[+-]\d\d:?(\d\d)?|Z/, function(g) {
      (this.zone || (this.zone = {})).offset = function(D) {
        if (!D || D === "Z")
          return 0;
        var v = D.match(/([+-]|\d\d)/g), C = 60 * v[1] + (+v[2] || 0);
        return C === 0 ? 0 : v[0] === "+" ? -C : C;
      }(g);
    }], T = function(g) {
      var D = t[g];
      return D && (D.indexOf ? D : D.s.concat(D.f));
    }, E = function(g, D) {
      var v, C = t.meridiem;
      if (C) {
        for (var B = 1; B <= 24; B += 1)
          if (g.indexOf(C(B, 0, D)) > -1) {
            v = B > 12;
            break;
          }
      } else
        v = g === (D ? "pm" : "PM");
      return v;
    }, F = { A: [i, function(g) {
      this.afternoon = E(g, !1);
    }], a: [i, function(g) {
      this.afternoon = E(g, !0);
    }], Q: [s, function(g) {
      this.month = 3 * (g - 1) + 1;
    }], S: [s, function(g) {
      this.milliseconds = 100 * +g;
    }], SS: [f, function(g) {
      this.milliseconds = 10 * +g;
    }], SSS: [/\d{3}/, function(g) {
      this.milliseconds = +g;
    }], s: [l, m("seconds")], ss: [l, m("seconds")], m: [l, m("minutes")], mm: [l, m("minutes")], H: [l, m("hours")], h: [l, m("hours")], HH: [l, m("hours")], hh: [l, m("hours")], D: [l, m("day")], DD: [f, m("day")], Do: [i, function(g) {
      var D = t.ordinal, v = g.match(/\d+/);
      if (this.day = v[0], D)
        for (var C = 1; C <= 31; C += 1)
          D(C).replace(/\[|\]/g, "") === g && (this.day = C);
    }], w: [l, m("week")], ww: [f, m("week")], M: [l, m("month")], MM: [f, m("month")], MMM: [i, function(g) {
      var D = T("months"), v = (T("monthsShort") || D.map(function(C) {
        return C.slice(0, 3);
      })).indexOf(g) + 1;
      if (v < 1)
        throw new Error();
      this.month = v % 12 || v;
    }], MMMM: [i, function(g) {
      var D = T("months").indexOf(g) + 1;
      if (D < 1)
        throw new Error();
      this.month = D % 12 || D;
    }], Y: [/[+-]?\d+/, m("year")], YY: [f, function(g) {
      this.year = M(g);
    }], YYYY: [/\d{4}/, m("year")], Z: A, ZZ: A };
    function k(g) {
      var D, v;
      D = g, v = t && t.formats;
      for (var C = (g = D.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(w, $, P) {
        var H = P && P.toUpperCase();
        return $ || v[P] || n[P] || v[H].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(h, c, a) {
          return c || a.slice(1);
        });
      })).match(o), B = C.length, L = 0; L < B; L += 1) {
        var x = C[L], O = F[x], N = O && O[0], R = O && O[1];
        C[L] = R ? { regex: N, parser: R } : x.replace(/^\[|\]$/g, "");
      }
      return function(w) {
        for (var $ = {}, P = 0, H = 0; P < B; P += 1) {
          var h = C[P];
          if (typeof h == "string")
            H += h.length;
          else {
            var c = h.regex, a = h.parser, d = w.slice(H), u = c.exec(d)[0];
            a.call($, u), w = w.replace(u, "");
          }
        }
        return function(p) {
          var y = p.afternoon;
          if (y !== void 0) {
            var S = p.hours;
            y ? S < 12 && (p.hours += 12) : S === 12 && (p.hours = 0), delete p.afternoon;
          }
        }($), $;
      };
    }
    return function(g, D, v) {
      v.p.customParseFormat = !0, g && g.parseTwoDigitYear && (M = g.parseTwoDigitYear);
      var C = D.prototype, B = C.parse;
      C.parse = function(L) {
        var x = L.date, O = L.utc, N = L.args;
        this.$u = O;
        var R = N[1];
        if (typeof R == "string") {
          var w = N[2] === !0, $ = N[3] === !0, P = w || $, H = N[2];
          $ && (H = N[2]), t = this.$locale(), !w && H && (t = v.Ls[H]), this.$d = function(d, u, p, y) {
            try {
              if (["x", "X"].indexOf(u) > -1)
                return new Date((u === "X" ? 1e3 : 1) * d);
              var S = k(u)(d), I = S.year, b = S.month, _ = S.day, j = S.hours, G = S.minutes, q = S.seconds, z = S.milliseconds, V = S.zone, Y = S.week, U = /* @__PURE__ */ new Date(), X = _ || (I || b ? 1 : U.getDate()), Z = I || U.getFullYear(), rt = 0;
              I && !b || (rt = b > 0 ? b - 1 : U.getMonth());
              var nt, it = j || 0, at = G || 0, st = q || 0, ct = z || 0;
              return V ? new Date(Date.UTC(Z, rt, X, it, at, st, ct + 60 * V.offset * 1e3)) : p ? new Date(Date.UTC(Z, rt, X, it, at, st, ct)) : (nt = new Date(Z, rt, X, it, at, st, ct), Y && (nt = y(nt).week(Y).toDate()), nt);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(x, R, O, v), this.init(), H && H !== !0 && (this.$L = this.locale(H).$L), P && x != this.format(R) && (this.$d = /* @__PURE__ */ new Date("")), t = {};
        } else if (R instanceof Array)
          for (var h = R.length, c = 1; c <= h; c += 1) {
            N[1] = R[c - 1];
            var a = v.apply(this, N);
            if (a.isValid()) {
              this.$d = a.$d, this.$L = a.$L, this.init();
              break;
            }
            c === h && (this.$d = /* @__PURE__ */ new Date(""));
          }
        else
          B.call(this, L);
      };
    };
  });
})(Ct);
var kt = Ct.exports;
const Bt = /* @__PURE__ */ At(kt);
tt.extend(Bt);
const se = async (e, r, n = gt) => {
  const o = await n(
    () => ht.getJwtToken({
      username: e,
      password: r
    })
  );
  return (o == null ? void 0 : o.userToken) || "";
}, mt = Ft.getInstance(), ce = async (e, r, n) => {
  var l, i;
  let o = {}, s = {};
  [o, s] = await Promise.all([
    r(),
    ht.checkUserExist({ username: e ?? "" })
  ]), mt.log(o == null ? void 0 : o.responseBody, s, "profileResponse");
  const f = !((l = o == null ? void 0 : o.responseBody) != null && l.code) && !(s != null && s.isExist);
  return n == null || n(f), {
    isUnique: f,
    usageStatus: ((i = o == null ? void 0 : o.responseBody) == null ? void 0 : i.code) ?? ""
  };
}, Ht = ({ config: e, fieldNames: r }) => e.filter((n) => r.includes(n == null ? void 0 : n.fieldName)), ue = ({ config: e, pk: r }) => e.filter((n) => r.includes(n == null ? void 0 : n.pk)), le = (e, r, n, o = !1) => {
  const s = {};
  return e.forEach((f) => {
    let l;
    const i = f.fieldName;
    if (f.validations)
      for (const [M, m] of Object.entries(f.validations))
        M === r && (l = m);
    if (!l)
      return;
    let t = K.string();
    l.required ? t = t.required(`profile.validationMsg.${f.fieldName}.required`) : t.nullable(), n && l.regex ? t = t.matches(
      l.regex,
      `profile.validationMsg.foreigner${f.fieldName}.format`
    ) : l.regex && (t = t.matches(
      l.regex,
      `profile.validationMsg.${f.fieldName}${o ? ".coapp" : ""}.format`
    )), s[i] = t;
  }), K.object().shape(s);
}, fe = (e) => Object.keys(e).reduce((n, o) => ({ ...n, [o]: !0 }), {}), de = (e) => (e.forEach((r) => {
  var n;
  r.validations = ((n = r == null ? void 0 : r.COAPP) == null ? void 0 : n.validations) ?? (r == null ? void 0 : r.validations) ?? {};
}), e), he = (e, r) => {
  const n = {};
  return e.forEach((o) => {
    const { fieldName: s, validations: f, fieldType: l } = o;
    if (!f)
      return;
    const i = f[r] ?? f.ALL;
    if (!i)
      return;
    let t = K.string();
    (i == null ? void 0 : i.visible) !== !1 && ((l == Q.CHECKBOX || l == Q.CUSTOM) && i.required ? t = K.boolean().required(`profile.validationMsg.${s}.required`).oneOf([!0], `profile.validationMsg.${s}.required`) : l == Q.FILE && i.required ? t = K.object().shape({
      [ot.Front]: K.boolean().oneOf([!0]).required(`profile.validationMsg.${s}.required`),
      [ot.Back]: K.boolean().oneOf([!0]).required(`profile.validationMsg.${s}.required`)
    }).test(
      "bothRequired",
      "Both front and back must be true",
      (m) => m && m[ot.Front] === !0 && m[ot.Back] === !0
    ) : l == Q.DYNAMIC ? t = K.string().test(`${s}Validator`, "", function(m) {
      return m === dt || !(i != null && i.required) && !m ? !0 : i != null && i.required && m === void 0 ? this.createError({ message: "" }) : this.createError({ message: m });
    }) : i != null && i.required && (t = K.string(), t = t.required(`profile.validationMsg.${s}.required`)), i != null && i.regex && (t = t.matches(
      new RegExp(i.regex),
      `profile.validationMsg.${s}.format`
    )));
    const M = l == Q.DYNAMIC ? `${s}Validator` : s;
    n[M] = t;
  }), K.object().shape(n);
}, ge = (e, r) => {
  let n;
  return e.forEach((o) => {
    const s = o.options;
    for (const [f, l] of Object.entries(s))
      f === r && (n = l);
  }), n;
}, Tt = (e) => btoa(
  JSON.stringify({
    redirectUri: e,
    headers: ApiConfigService.getTuples()
  })
), jt = (e = [], r) => e.reduce((o, s) => (Object.prototype.hasOwnProperty.call(s, r) && (o[s[r]] = s), o), {}), Ut = (e) => {
  const { NEXT_PUBLIC_GLU_CLIENT_ID: r, NEXT_PUBLIC_BASE_PATH: n } = ConfigService.getConfigs();
  return {
    scope: "openid",
    state: Tt(e),
    clientId: `${r}`,
    redirectUri: `${n}/comgluuoidc/v1/auth`,
    acrValues: "basic_jans_key",
    // Add for new version
    gluuBaseUrl: "",
    responseType: "code",
    prompt: "",
    loginHint: ""
  };
}, me = (e, r, n = gt) => {
  const { NEXT_PUBLIC_GLU_BASE_URL: o, NEXT_PUBLIC_TENANT: s } = ConfigService.getConfigs();
  if (e && s !== "200") {
    const f = ApiConfigService.getTuples(), i = {
      ...Ut(r),
      countryIso: f["X-Amway-Country"],
      gluuBaseUrl: o,
      acrValues: "BCAuthn",
      bcAuthnToken: e,
      state: Tt(r)
    };
    n(
      () => ht.getAuthorizeUrl(i).then((t) => {
        window.location.href = t;
      })
    );
  }
}, Vt = (e, r) => {
  const n = {
    min: 0,
    max: 0
  };
  return e.forEach((o) => {
    const s = o.validations;
    for (const [f, l] of Object.entries(s))
      f === r && (l.min && (n.min = l.min), l.max && (n.max = l.max));
  }), n;
};
function pe(e, r, n = [], o, s, f) {
  var E, F;
  const i = Ht({
    config: n,
    fieldNames: ["birthDate", "minorAge"]
  }), { min: t, max: M } = Vt(i, r), m = i.find((k) => k.pk === "birthDate"), A = (F = (E = m == null ? void 0 : m.validations) == null ? void 0 : E[r]) == null ? void 0 : F.ageCalAtyearEnd, T = { msg: "", additionalDocument: !1 };
  if (e) {
    const k = vt(e, o, !0), g = vt(e, o, !1);
    if (g <= 0 || !Ot.test(e) || g > Nt.MAX_AGE)
      return T.msg = f("profile.RegistrationPersonalDetailsStep.invalidDate"), T;
    if (A && k < t)
      return T.msg = xt(
        s,
        f("profile.RegistrationPersonalDetailsStep.CoAppDateError", { age: t }),
        f("profile.RegistrationPersonalDetailsStep.AboDateError")
      ), T;
    if (A && k == t || g >= t && g <= M)
      return T.msg = "", T.additionalDocument = !0, T;
    if (!A && g < t)
      return T.msg = f(`profile.RegistrationPersonalDetailsStep.memberDateError${s ? ".coapp" : ""}`, {
        age: t
      }), T;
  }
  return T;
}
const vt = (e, r, n, o = "DD/MM/YYYY") => {
  let s = tt(e, o);
  r && (s = s.subtract(543, "year"));
  const f = /* @__PURE__ */ new Date(), l = tt(new Date(f.getFullYear(), 12, 0));
  return (n ? l : tt(f)).diff(s, "years");
}, ye = (e) => {
  const [r, n, o] = e.split("/").map(Number), s = /* @__PURE__ */ new Date();
  return s.setFullYear(o - 543), s.setMonth(n - 1), s.setDate(r), s;
}, Kt = (e) => {
  const r = new Date(e), n = ("0" + r.getDate()).slice(-2), o = ("0" + (r.getMonth() + 1)).slice(-2), s = r.getFullYear() + 543;
  return `${n}/${o}/${s}`;
}, $e = (e, r, n = Yt.BusinessOwner, o = !1) => {
  var s;
  if (e) {
    const { [r]: f } = e;
    if (Lt.includes(r)) {
      const l = f == null ? void 0 : f.steps, i = o ? "showForAnonymous" : "showForLoggedIn", t = {};
      l && ((s = Object.keys(l)) == null || s.forEach((M) => {
        var T, E, F;
        const m = (E = (T = l == null ? void 0 : l[M]) == null ? void 0 : T.config) == null ? void 0 : E[n];
        ((F = m == null ? void 0 : m.find((k) => k.key === i)) == null ? void 0 : F.value) === "true" && (t[M] = l == null ? void 0 : l[M]);
      }), f.steps = t);
    }
    return f;
  }
  return {};
}, Se = (e, r) => {
  let n = {
    isFieldDisabled: !1
  };
  return r !== _t.Passport && (n = {
    ...n,
    firstName: e.givenName,
    lastName: e.familyName,
    birthDate: Kt(e.birthDate)
  }), n;
}, ve = (e, r) => {
  const [n, o, s] = e.split("/").map(Number), f = o.toString().length === 1 ? `0${o}` : o, l = n.toString().length === 1 ? `0${n}` : n;
  return `${r ? s - 543 : s}-${f}-${l}`;
}, Me = (e) => {
  let r = {};
  return e.sponsor && e.sponsorLocation && (r = {
    accountName: e.sponsorName,
    accountNumber: e.sponsor,
    location: e.sponsorLocation
  }), r;
}, De = (e) => tt(e), Ae = (e, r) => tt(e, r, !0).isValid(), we = (e, r = "") => {
  if ((e == null ? void 0 : e.flowName) === W.CoApplicantFlow) {
    const { cidVerification: n } = e, { spousePersonalId: o } = n ?? { spousePersonalId: "" };
    if (o)
      return {
        headers: {
          "X-Auth-Token": btoa(`${W.CoApplicantFlow}-${o}`)
        }
      };
  }
  return r ? {
    headers: {
      "X-Amway-Regtkn": r
    }
  } : {
    headers: {}
  };
}, Ce = (e, r, n) => n != null && n.accountNumber ? r ? { ...n, accountName: r } : n : e, Te = (e, r) => {
  var n, o;
  return !!(!e && ((n = r == null ? void 0 : r.spousePersonalId) != null && n.recordNumber) || // Standard registration
  e && ((o = r == null ? void 0 : r.personalId) != null && o.recordNumber));
}, Ie = (e, r, n) => {
  try {
    const o = r(e);
    return o === e ? r(n) : o;
  } catch (o) {
    return mt.info(o, "error"), n;
  }
}, be = (e, r, n) => {
  try {
    let o = r(e);
    return o === e && n && (o = r(n)), o === n && (o = r(pt.body)), o;
  } catch (o) {
    return mt.info(o, "error"), r(pt.body);
  }
}, Ee = (e, r) => {
  if (e !== W.SelfInitiatedFlow) {
    const n = et.getLocalStorage(), o = n.retrieve(
      J.shareCodeAttributes
    );
    delete o.accountId, n.store(J.shareCodeAttributes, o);
  }
  r == null || r();
}, Oe = (e, r) => {
  var n;
  if (e) {
    const s = (n = ApiConfigService.getTuples()["X-Amway-Country"]) == null ? void 0 : n.toUpperCase();
    e.countryCode = s, r == null || r(e);
  }
}, Wt = () => {
  et.getSessionStorage().remove(J.registrationInfoKey);
}, Ne = (e, r, n) => {
  const { REGISTRATION_REFRESH_RETAIN: o = !0 } = ConfigService.getConfigs(), s = et.getSessionStorage();
  o && s.store(J.registrationInfoKey, {
    registrationId: e,
    challengeId: r,
    currentIndex: n
  });
}, Le = (e) => {
  const { REGISTRATION_REFRESH_RETAIN: r = !0 } = ConfigService.getConfigs();
  if (r) {
    const n = et.getSessionStorage(), o = n.retrieve(
      J.registrationInfoKey
    );
    o && (o.currentIndex = e, n.store(J.registrationInfoKey, o));
  }
}, _e = async (e, r, n, o = "") => {
  var B, L, x;
  const { REGISTRATION_REFRESH_RETAIN: s = !0 } = ConfigService.getConfigs();
  if (!s) {
    r({});
    return;
  }
  let f = {};
  const i = et.getSessionStorage().retrieve(
    J.registrationInfoKey
  );
  if (!(i != null && i.registrationId) || (i == null ? void 0 : i.currentIndex) >= e.length) {
    Wt(), r({});
    return;
  }
  const t = await Mt.getRegistrationDetailsById(
    i == null ? void 0 : i.registrationId,
    {
      headers: { "X-Amway-Regtkn": i == null ? void 0 : i.challengeId }
    },
    `${yt.FULL},${yt.DOCUMENTS}`
  ), M = (B = t == null ? void 0 : t.personalIdList) == null ? void 0 : B.find((O) => O == null ? void 0 : O.recordNumber), m = (L = t == null ? void 0 : t.personalIdList) == null ? void 0 : L.filter(
    (O) => {
      var N;
      return ((N = O == null ? void 0 : O.documentDataList) == null ? void 0 : N.length) !== 0;
    }
  ), A = m == null ? void 0 : m.reduce(
    (O, N) => {
      var w;
      const R = (w = N == null ? void 0 : N.documentDataList) == null ? void 0 : w.filter(
        ($) => !!($ != null && $.documentData)
      );
      return [...O, ...R];
    },
    []
  ), T = t == null ? void 0 : t.registrationFlow, E = e == null ? void 0 : e[i.currentIndex], F = !!(t != null && t.prePrintedKitId), k = (t == null ? void 0 : t.usernameContactType) ?? ft.Email, g = (x = t == null ? void 0 : t.phone) == null ? void 0 : x.replace(o, ""), D = k === ft.Phone ? g : t == null ? void 0 : t.email, v = (t == null ? void 0 : t.internationalSponsor) ?? {};
  let C = {};
  Object.keys(v).length !== 0 && (v.accountName = v == null ? void 0 : v.sponsorName, v.location = t == null ? void 0 : t.sponsorLocation, C = {
    internationalSponsorCountryCode: v == null ? void 0 : v.countryCode,
    internationalSponsorTncCheckbox: !0,
    internationalSponsorType: "international",
    internationalSposnorVerified: !0,
    isInternational: !0,
    setInternationalSponsor: !0
  }), f = {
    mainData: {
      currentIndex: i.currentIndex,
      currentStepName: E == null ? void 0 : E.stepName,
      isRefreshRestoredData: (t == null ? void 0 : t.registrationFlow) !== W.CoApplicantFlow,
      phonePrimaryContactSession: k === ft.Phone,
      aboKitVerified: F,
      doNotKnowSponsor: t == null ? void 0 : t.doNotKnowSponsor,
      documentDataList: A
    },
    accountType: t == null ? void 0 : t.accountType,
    userData: {
      registrationId: i == null ? void 0 : i.registrationId,
      patchVersion: t == null ? void 0 : t.version
    },
    OtpData: {
      challengeId: i == null ? void 0 : i.challengeId,
      isOTPVerified: !0
    },
    perosonalDetails: {
      isFieldDisabled: !1,
      firstName: t == null ? void 0 : t.givenName,
      lastName: t == null ? void 0 : t.familyName,
      userName: D,
      birthDate: t == null ? void 0 : t.birthDate,
      gender: t == null ? void 0 : t.gender,
      email: t == null ? void 0 : t.email,
      phone: t == null ? void 0 : t.phone,
      userNameValidator: dt,
      secondaryContactValidator: dt,
      personalIdType: M == null ? void 0 : M.recordType,
      personalIdRecordNumber: M == null ? void 0 : M.recordNumber,
      taxRegime: t == null ? void 0 : t.taxRegime,
      citizenshipCountry: t == null ? void 0 : t.citizenshipCountry,
      createPassword: "*********",
      password: "*********",
      termsAndConditionCheckbox: !0,
      address: {
        addrLineOne: "",
        addrLineTwo: "",
        state: "",
        city: "",
        postalCode: "",
        province: "",
        provinceCode: "",
        district: "",
        subDistrict: "",
        countryCode: "",
        ...t == null ? void 0 : t.billingAddress
      },
      personalIdDocument: (A == null ? void 0 : A.length) == 2 ? { FRONT: !0, BACK: !0 } : void 0
    },
    selectSponsor: {
      editSponsor: T !== W.ShareBarFlow,
      sponsor: {
        accountName: t == null ? void 0 : t.sponsorName,
        accountNumber: t == null ? void 0 : t.sponsor,
        location: t == null ? void 0 : t.sponsorLocation
      },
      internationalSponsor: t == null ? void 0 : t.internationalSponsor,
      hideSponsorRadioSelection: !0,
      ...C
    }
  }, F && n(!0), r(f);
}, Fe = (e, r, n, o) => {
  const s = jt(e, r), f = {};
  return Object.keys(s).forEach((l) => {
    var M, m, A, T;
    let { validations: i } = s[l];
    o === W.CoApplicantFlow && (i = (m = (M = s == null ? void 0 : s[l]) == null ? void 0 : M.COAPP) == null ? void 0 : m.validations);
    const t = ((A = i == null ? void 0 : i[n]) == null ? void 0 : A.visible) ?? ((T = i == null ? void 0 : i.ALL) == null ? void 0 : T.visible);
    f[l] = t ?? !1;
  }), f;
}, qt = (e) => {
  const { NEXT_PUBLIC_REGISTRATION_WITH_STARTER_KIT_FLOW: r } = ConfigService.getConfigs(), n = Array.isArray(r) ? r : [];
  return n == null ? void 0 : n.includes(e);
}, Xt = (e) => new Promise((r) => {
  e(!0);
  const n = (o, s, f) => {
    e(!1), r({ kit: o, fee: s, rejected: f });
  };
  window.handleSkuSelect = n;
}), Ye = async (e, r, n, o = $t.MEPANEL) => {
  let s = "", f = "", l = !1, i = r, t = !1;
  if (qt(e)) {
    if (e === W.ShareBarFlow && r === ut.CHECKOUT)
      return { starterKitSku: s, useNewCartForCheckout: l, returnUrl: i };
    const { kit: M, fee: m, rejected: A } = await Xt(n);
    if (s = M, f = m, t = A, e === W.ShareBarFlow && o !== $t.MEPANEL)
      return { starterKitSku: s, feeSku: f, useNewCartForCheckout: l, returnUrl: i, rejected: t };
    i = ut.CHECKOUT, r === ut.CART && (l = !0);
  }
  return { starterKitSku: s, feeSku: f, useNewCartForCheckout: l, returnUrl: i, rejected: t };
}, xe = async (e, r = gt) => {
  const n = await It(void 0, e, bt.Completed, !0);
  let o = "";
  if (n) {
    const s = await r(
      () => Mt.getRegistrationDetailsById(St(n), {}, Et.Full)
    ), { spousePersonalId: f } = Rt(s);
    o = St(f == null ? void 0 : f.recordNumber);
  }
  return o;
}, Re = (e) => {
  let r = e;
  return r != null && r.startsWith(" ") && (r = r == null ? void 0 : r.trimStart()), r = r == null ? void 0 : r.replace(/ {2,}/g, " "), r;
}, Pe = (e) => {
  switch (e) {
    case W.AboLedFlow:
      return lt.aboLedFlow;
    case W.CoApplicantFlow:
      return lt.coApplicantFlow;
    default:
      return lt.selfInitiatedFlow;
  }
}, ke = (e, r) => {
  const n = { version: e.version };
  return delete e.version, r && (n.coapplicantData = {
    [r]: {
      ...e
    }
  }), n;
};
export {
  fe as A,
  Ne as B,
  ve as C,
  _e as D,
  Q as E,
  Ut as F,
  Se as G,
  Wt as H,
  Ye as I,
  Me as J,
  Ce as K,
  me as L,
  Vt as M,
  ye as N,
  Kt as O,
  Ie as P,
  qt as Q,
  Xt as R,
  be as a,
  xe as b,
  se as c,
  De as d,
  ue as e,
  we as f,
  vt as g,
  Ht as h,
  ge as i,
  le as j,
  Te as k,
  Fe as l,
  he as m,
  Ee as n,
  ce as o,
  Ae as p,
  de as q,
  ot as r,
  Le as s,
  jt as t,
  ke as u,
  pe as v,
  $e as w,
  Pe as x,
  Re as y,
  Oe as z
};
//# sourceMappingURL=registrationUtils-cd634943.mjs.map
